import { Button } from 'antd'
// import { inject, observer } from 'mobx-react';
import oGet from 'lodash/get'
import { useObserver } from 'mobx-react'
import React, { useCallback, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { ReactComponent as ArrowDownIcon } from '../../assets/img/icon/search_arrow_down.svg'
import { ReactComponent as UserIcon } from '../../assets/img/icon/user_icon.svg'
import { useUserStore } from '../../store'
import { Config, IS_ELECTRON } from '../../utils/config'
import { delCookie } from '../../utils/cookie'
import { ipcSendCocoFaxAction } from '../../utils/ipcRenderer'

function navigationToHome() {
  if (IS_ELECTRON) {
    ipcSendCocoFaxAction('logout', { clearCookie: true })
    return
  }
  window.location.href = Config.mainDomain
}

const logout = (e) => {
  e.preventDefault()
  delCookie('cocofaxName')
  delCookie('cocofaxToken')
  delCookie('cocofaxOrderInfo')
  delCookie('cocofaxBought')
  navigationToHome()
}

function SearchTop() {
  const userStore = useUserStore()

  const [clickCount, setClickCount] = useState(0)
  const [clickTimer, setClickTimer] = useState(null)

  useEffect(() => {
    return () => {
      if (clickTimer) {
        clearTimeout(clickTimer)
      }
    }
  }, [clickTimer])

  const onNullClick = useCallback(() => {
    if (clickTimer) {
      clearTimeout(clickTimer)
      setClickTimer(null)
    }
    setClickCount(clickCount + 1)
    if (clickCount >= 5) {
      ipcSendCocoFaxAction('openDevTools')
    }
    setClickTimer(
      setTimeout(() => {
        setClickCount(0)
      }, 300)
    )
  }, [clickCount, clickTimer])

  return useObserver(() => {
    const { isUserFreeType, isUserGroupMember, userInfo } = userStore
    const userEmail = oGet(userInfo, 'email', 'CocoFax@gamil.com')

    return (
      <div className="gp-nav flexible flex-justify-end" onClick={onNullClick}>
        {/* {isUserFreeType && !isUserGroupMember ? (
          <Button
            type="primary"
            danger
            href={Config.PRICING_URL}
            target="_blank"
            style={{ marginRight: 36, marginTop: 7, height: 26, lineHeight: '26px', width: 100, padding: '0 10px', fontSize: 12 }}
          >
            Upgrade Now
          </Button>
        ) : null} */}
        <div className="user-name flexible flex-align-center">
          <UserIcon />
          <span className="email">{userEmail}</span>
          <ArrowDownIcon />
        </div>
        <div className="pull-nav">
          <ul>
            <li>
              <Link to={{ pathname: '/page/profile' }}>Profile</Link>
            </li>
            <li>
              <a href="https://cocofax.firstpromoter.com/" target="_blank" rel="nofollow">
                Refer a friend
              </a>
            </li>
            <li>
              <a onClick={logout}>Logout</a>
            </li>
          </ul>
        </div>
      </div>
    )
  })
}

export default SearchTop
